import { createSlice } from "@reduxjs/toolkit";

import { DEFAUT_VALUEE_FILTERS } from "../../../../../pages/MainPage/pages/Accounting/tabs/ReplenishPerformersBalance/components/Header/components/Filter/constants";
import { DateFns } from "../../../../../utils/DateFns";
import { ReduxReducer } from "../../../../interface";
import { Accounting } from "../../interface";

import { State } from "./interface";

const baseDateFns = new DateFns();

const initialState: State = {
	dateRange: {
		from: baseDateFns.startDate(),
		to: baseDateFns.endDate(),
	},
	query: "",
	byMultyFilters: DEFAUT_VALUEE_FILTERS,
};

const setDateFrom: ReduxReducer<State, Date> = (state, { payload }) => {
	state.dateRange.from = payload;
};

const setDateTo: ReduxReducer<State, Date> = (state, { payload }) => {
	state.dateRange.to = payload;
};

const setQuery: ReduxReducer<State, State["query"]> = (state, { payload }) => {
	state.query = payload;
};

const setFiltersByMultyFilters: ReduxReducer<State, State["byMultyFilters"]> = (
	state,
	{ payload },
) => {
	state.byMultyFilters = payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const filters = createSlice({
	name: Accounting.ConstantAccountingSlice.REPLENISHMENTS_FILTERS,
	initialState,
	reducers: {
		reset,
		setDateFrom,
		setDateTo,
		setQuery,
		setFiltersByMultyFilters,
	},
});

export const filtersAction = filters.actions;
export const filtersReducer = filters.reducer;
export type filtersState = State;

export default filters;
